import { I18N_NS } from "Config/i18n";
import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { loginSettingsData } from "Stores";
import { RouterStore } from "Config/CustomBrowserRouter";
import { notificationError } from "utils/libHelpers/AntdNotification";

interface ErrorBoundaryProps extends WithTranslation {}

export const ErrorBoundary = withTranslation(I18N_NS.GENERAL)(
  class extends React.Component<React.PropsWithChildren<ErrorBoundaryProps>> {
    componentDidCatch(error: Error, info: React.ErrorInfo): void {
      const { t } = this.props;
      const timestamp = new Date().toUTCString();
      const appVersion = { BE: loginSettingsData.data.backendVersion, FE: import.meta.env.VITE_APP_VERSION };
      const browser = window.navigator.userAgent;
      const environment = window.GLOBAL.API_BASE;

      // Object with information about error for sending to logging server
      const errorData = {
        appVersion,
        timestamp,
        browser,
        environment,
        error: { name: error.name, stacktrace: info.componentStack },
      };
      this.sendErrorLog(errorData);

      if (process.env.NODE_ENV !== "development") {
        RouterStore.push("/dashboard");
      }

      notificationError(
        t("Something technical went wrong."),
        t("Error occurred while accessing project. Please, contact support.")
      );
    }

    // TODO: handle sending logs to back-end
    sendErrorLog(obj: object) {
      return obj;
    }

    render() {
      return this.props.children;
    }
  }
);
